/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {NgxEditorService as ɵb,NgxEditorServiceConfig as ɵa,provideMyServiceOptions as ɵc} from './lib/ngx-editor.service';